import { FC, useCallback, useMemo } from 'react';
import Deck from '../Seats/Deck';
import { Box, Typography } from '@mui/material';
import { getSortedUniquePrices } from '../../helpers/getAveragePrices';

interface SeatPanelProps {
  seatData: any;
  selectedSegment: { from: string, to: string };
  totalTravellers: number;
  updateSmbAction: any;
  selectedSmbData: any;
}

const SeatPanel: FC<SeatPanelProps> = ({
  seatData, 
  selectedSegment, 
  totalTravellers,
  updateSmbAction,
  selectedSmbData
}) => {
  const getSeatMapBasedOnSegment = useCallback((smbData: any[], selectedSegment: { from: string, to: string }) => {
    const segmentAncillariesArray = smbData
      ?.filter((item: any) => item?.segmentAncillaries)
      ?.map((item: any) => item?.segmentAncillaries)
      ?.flat();

    const seatAncillaries = segmentAncillariesArray?.find((segmentAncillary: any) =>
      segmentAncillary?.originDestinationInfo?.from === selectedSegment?.from &&
      segmentAncillary?.originDestinationInfo?.to === selectedSegment?.to
    );

    return seatAncillaries?.seatAncillaries?.aircraftLayout;
  }, []);

  const seatMapBasedOnSegment = useMemo(() => getSeatMapBasedOnSegment(seatData, selectedSegment), [selectedSegment]);
  
  const compartments = seatMapBasedOnSegment?.lowerDeck?.compartments || {};
  const rows: any = Object.values(compartments)?.flatMap((compartment: any) => compartment?.rows || []);
  const getPriceArray = getSortedUniquePrices([rows]);
  
  return (
    <Box>
      <Box width='100%' overflow='scroll' display='flex' position='sticky' top='187px' bgcolor='white' zIndex={10}>
        {getPriceArray?.map((price: any) => (
          <Box bgcolor='white' key={price?.price} p='8px' pl='16px' 
            display='flex' justifyContent='space-between' alignItems='center'>
            <Box bgcolor={price?.primaryColor} height='16px' width='16px' borderRadius='3px' />
            <Typography ml='8px' variant='body2'>{price?.displayPrice}</Typography>
          </Box>
        ))}
      </Box>
      <Box px='16px'>
      <Deck 
        seatMap={seatData} 
        selectedSegment={selectedSegment} 
        totalTravellers={totalTravellers}  
        updateSmbAction={updateSmbAction}
        selectedSmbData={selectedSmbData}
        priceColorArray={getPriceArray}
      />
      </Box>
    </Box>
  );
};

export default SeatPanel;